import moment, { Moment } from "moment";

export const GetDayRange = (date: Date): [Moment, Moment] => [
  moment(date).startOf("day"),
  moment(date).endOf("day"),
];
